import { render, staticRenderFns } from "./c_data_management_home.vue?vue&type=template&id=7f6aff83&scoped=true&"
import script from "./c_data_management_home.vue?vue&type=script&lang=js&"
export * from "./c_data_management_home.vue?vue&type=script&lang=js&"
import style0 from "./c_data_management_home.vue?vue&type=style&index=0&id=7f6aff83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6aff83",
  null
  
)

export default component.exports